/* eslint-disable */
import React from "react"

import { Grid, Stack, Typography } from "@mui/material"

import useAudioContext from '../../../utils/eSteth/AudioState'
import DeviceForm from "../../../components/DeviceForm"
import AudioPlot from "../../../components/AudioPlot"
import DeviceInfo from "../../../components/DeviceInfo"

const HomePage = () => {
	const { device } = useAudioContext()
	return (
		<Stack sx={boxSX} spacing={1}>
			<Typography variant="h5">{`ESteth UI ${device ? `/${device.device} ` : ``}`}</Typography>
			<Grid container spacing={2} sx={{ width: "100%" }} columns={24}>
				<Grid item lg={5} md={5} sm={3} xs={0} />
				<Grid item lg={7} md={7} sm={9} xs={12}>
					<DeviceForm />
				</Grid>
				<Grid item lg={7} md={7} sm={9} xs={12}>
					<DeviceInfo />
				</Grid>
				<Grid item lg={5} md={5} sm={3} xs={0} />
				<Grid item lg={5} md={5} sm={3} xs={0} />
				<Grid item lg={14} md={14} sm={18} xs={24}>
					<AudioPlot />
				</Grid>
				<Grid item lg={5} md={5} sm={3} xs={0} />
			</Grid>
		</Stack>
	)
}

const boxSX = {
	width: "100vw",
	minHeight: "100vh",
	maxHeight: "100vh",
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "start",
}

export default HomePage

